import { useQuery } from '@tanstack/react-query'
import { fetchPayrollDownloadUrls } from '../api/payroll-api'

export default function usePayrollDownloadUrls(customerId: string) {
  return useQuery({
    queryKey: ['payroll-download-urls', customerId],
    queryFn: () => fetchPayrollDownloadUrls(customerId),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchInterval: 4 * 60 * 1000, // Refetch every 4 minutes
    retry: 2, // Retry failed requests twice
    retryDelay: 1000, // Wait 1 second between retries
    enabled: !!customerId, // Only run query if customerId is provided
  })
}
